import LogoutIcon from "@mui/icons-material/Logout";
import { Box, Button, IconButton, useMediaQuery } from "@mui/material";
import { Container } from "@mui/system";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { NavLink, useNavigate } from "react-router-dom";
import vwLogo from "../../assets/images/logo-vw.svg";
import { AuthContext } from "../../contexts/AuthContext";
import { useSidebar } from "../../contexts/SidebarContext";
import useCookies from "../../services/CookieService";
import ButtonCountry from "../button/ButtonCountry";
import ButtonLanguage from "../button/ButtonLanguage";
import HamburguerMenu from "../menu/HamburguerMenu";

export default function Header() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { signOut, user } = useContext(AuthContext);
  const { open: sidebarOpen } = useSidebar();

  const matches = useMediaQuery("(max-width:899px)");

  const logout = () => {
    signOut();
  };

  const sidebarWidth = sidebarOpen ? 260 : 72;

  const controls = (
    <>
      <ButtonLanguage />
      {user && <ButtonCountry />}

      {user && matches && (
        <IconButton type="button" onClick={logout}>
          <LogoutIcon sx={{ color: "var(--gray-900)" }} />
        </IconButton>
      )}
      {user && !matches && (
        <Button sx={{ color: "var(--gray-900)" }} onClick={logout}>
          {t("header.Exit")}
        </Button>
      )}
      {!user && matches && (
        <IconButton type="button" onClick={logout}>
          <LogoutIcon sx={{ color: "var(--gray-900)" }} />
        </IconButton>
      )}
      {!user && !matches && (
        <Button sx={{ color: "var(--gray-900)" }} onClick={logout}>
          {t("header.Sign in")}
        </Button>
      )}
    </>
  );

  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        display: "flex",
        boxShadow: "0 2px 3px rgb(0 0 0 / 15%)",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        height: 64,
        zIndex: 1201,
      }}
    >
      {matches ? (
        <Container
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            px: { xs: 1.5, sm: 2 },
          }}
        >
          <HamburguerMenu />
          <Box sx={{ display: "flex", alignItems: "center", gap: "1rem" }}>
            {controls}
          </Box>
        </Container>
      ) : (
        <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
          <Box
            sx={{
              width: sidebarWidth,
              flexShrink: 0,
              textAlign: "center",
              py: 0.5,
              transition: (theme) =>
                theme.transitions.create("width", {
                  easing: theme.transitions.easing.sharp,
                  duration: theme.transitions.duration.shorter,
                }),
            }}
          >
            <NavLink to="/home">
              <img src={vwLogo} alt="Volkswagen Logo" width="50px" />
            </NavLink>
          </Box>
          <Container
            sx={{
              flexGrow: 1,
              width: "100%",
              maxWidth: { xs: "100%", sm: "100%", md: "100%", lg: "1250px" },
              mx: "auto",
              px: 0,
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              gap: "1rem",
            }}
          >
            {controls}
          </Container>
        </Box>
      )}
    </Box>
  );
}
